import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// The app's own font sizes (globals.css `--text-*`) beside Tailwind's: without them tailwind-merge reads
// `text-reading` and `text-body` as colours, so `text-reading text-foreground` loses its size, and a later size
// doesn't replace an earlier one.
// The glass materials (glass.css) replace a component's own fill, border and shadow when they come after them, as
// on a Button, whose transparent border would otherwise win the cascade and hide the hairline.
const twMerge = extendTailwindMerge<"glass-control" | "frosted-surface" | "popover-glass-surface">({
  extend: {
    theme: { text: ["reading", "body"] },
    classGroups: {
      "glass-control": ["glass-control"],
      "frosted-surface": ["frosted-surface"],
      "popover-glass-surface": ["popover-glass-surface"],
    },
    conflictingClassGroups: {
      "glass-control": ["frosted-surface", "popover-glass-surface", "border-w", "border-color", "bg-color", "shadow", "backdrop-blur", "backdrop-saturate"],
      "frosted-surface": ["glass-control", "popover-glass-surface", "bg-color", "backdrop-blur", "backdrop-saturate"],
      "popover-glass-surface": ["glass-control", "frosted-surface", "bg-color", "backdrop-blur", "backdrop-saturate"],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
